<template>
    <div>
		<SelectionRequiredDialog /> 
		<DeletionDialog :context="'Selected' + context" />
        <GroupDialog />	
        <FileImportDialog :alvqaContext="alvqa +'-list'" />
        <MoveIntoCompanyDialog 
            :context="context"
            :message="$t('lang_CONTRACTS_LABEL_CAPTION_MOVE_CONTRACTS_TEXT')"
        />
        <ManageTagsDialog 
			:context="context"
			dir='contracts/label'
			idAttributeName='alvIds'
		/>

        <ExportDialog />
        <ConfirmationDialog />
        
        <BaseListPage
            headline="lang_CONTRACTS_LABEL_CONTRACTS"
			:context="context"
            :alvqa="alvqa"
            :stickyHeader="true"
        >

        <template v-slot:filter>
            <v-col cols="2">
                <DropdownFilter 
                    :context="context + 'QualityFilter'"
                    label="lang_GENERIC_CAPTION_QUALITY"
                    :items="qualityItems"
                    :alvqa="alvqa + '-list-dropdown-quality'"
                />
            </v-col>
        </template>

            <template v-slot:dataTable>
                <BaseDataTableList
                    :headers="headers"
                    :context="context" 
                    :alvqa="alvqa"
                    :hasServerSideSorting="true"
                    :stickyTopSlot="true"
                >
                    <template v-slot:topSlot><LabelContractsTopSlot /></template>
                    <template v-slot:body="{ item }">
                        <ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
						/>
                        <td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alvid'"
                        >
                            {{ item.item.alvId }}
                            <BaseTooltip v-if="item.item.groupName !== null && item.item.groupName !== undefined">
                                <template v-slot:text>
                                    {{ $t('lang_PUBLISHING_CONTRACTS_GROUPED_CONTRACTS') }}{{ item.item.groupName ? ': ' + item.item.groupName : '' }}
                                </template>
                                <template v-slot:content>
                                    <v-icon small color="grey darken-1" class="ml-1" style="transform:rotate(90deg)">linear_scale</v-icon>
                                </template>
                            </BaseTooltip>
                        </td>
                        <td class="ellipsis">
                            <BaseTooltip 
                                :simpleText="item.item.contractName"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contract-name'"
                           />
                        </td>

                        <td
                            class="ellipsis" 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contracting-party'"
                        >
                            <BaseTooltip>
                                <template v-slot:text>{{ item.item.licensor !== null ? $alvPlugin.showNameOfAzEntry(item.item.licensor) + ' (' + item.item.licensor.alvId + ')' : "" }}</template>
                                <template v-slot:content>
                                    <!-- {{ item.item.licensor !== null ? item.item.licensor.name : "" }} -->
                                    {{ $alvPlugin.showNameOfAzEntry(item.item.licensor) }}
                                </template>
                            </BaseTooltip>  
                        </td>

                        <td 
                            class="ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contract-type'"
                        >{{ item.item.contractType }}</td>
                        <td 
                            class="no_ellipsis text-right"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-connected-to'"
                        >{{ $n(item.item.connectedTo, 'numberInteger') }} {{ $t(getTrackLangConst(item.item.connectedTo)) }}</td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contract-date'">
                            {{ item.item.contractDate !== null ? $d(new Date(item.item.contractDate), 'alvDateFormat') : '' }}
                        </td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-reminder-date'">
                            {{ item.item.reminderDate !== null ? $d(new Date(item.item.reminderDate), 'alvDateFormat') : '' }}
                        </td>
                    </template>
                    <!-- EXPAND: Read Only View -->
                    <template v-slot:expandSlot="{ id }"><LabelContractsReadOnly :itemId='id' /></template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseListPage from '@/components/_base/BaseListPage'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import LabelContractsTopSlot from './LabelContractsTopSlot'
import LabelContractsReadOnly from './_readonly/LabelContractsReadOnly.vue'
import FileImportDialog from '@/components/_dialogs/FileImportDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import MoveIntoCompanyDialog from '@/components/_dialogs//MoveIntoCompanyDialog'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'
import ExportDialog from './_dialogs/ContractsLabelExportDialog'
import GroupDialog from './_dialogs/LabelContractsGroupDialog'
import ConfirmationDialog from '@/components/_dialogs/ConfirmationDialog'
import DropdownFilter from '@/components/_filters/DropdownFilter'

export default {
    name: "LabelContractsList",
    components: {
		BaseListPage,
        BaseDataTableList,
        BaseTooltip,
        ExpandIcon,
        LabelContractsTopSlot,
        FileImportDialog,
        DeletionDialog,
        SelectionRequiredDialog,
        LabelContractsReadOnly,
        MoveIntoCompanyDialog,
        ManageTagsDialog,
        ExportDialog,
        GroupDialog,
        ConfirmationDialog,
        DropdownFilter
    },
    data() {
        return {
            context: "LabelContracts",
            alvqa: "contracts-label"
        }
    },
    computed: {
		/** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, sortable: string, value: string}]} props of the header */
        headers() {
            return [   
				{
                    text: '', 
                    value: 'data-table-select', 
                    sortable: false,
                    width: "60px" 
                },
                {
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px",
					sortable: false,
					class: 'text-no-wrap'
				},
                {
                    text: this.$t('lang_GENERIC_CAPTION_ALVID'), 
                    value: 'alvId', 
                    align: 'left', 
                    sortable: false, 
                    width: "165px", 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CONTRACT_TITLE'), 
                    value: 'contractName',
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY'), 
                    value: 'licensor',
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE'), 
                    value: 'contractType', 
                    align: 'left', 
                    sortable: true, 
                    width: "130px", 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_CONNECTED_TO'), 
                    value: 'connectedTo',
                    align: 'right', 
                    sortable: false, 
                    width: "115px", 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_DATE'), 
                    value: 'contractDate',
                    align: 'left', 
                    sortable: true, 
                    width: "145px", 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_CONTRACTS_LABEL_CAPTION_REMINDER_DATE'), 
                    value: 'reminderDate',
                    align: 'left', 
                    sortable: true, 
                    width: "145px", 
                    class: 'text-no-wrap'
                },
                // {
				// 	text: '', 
				// 	value: 'ghost',
				// 	sortable: false,
                //     class: 'text-no-wrap'
				// },
                {
                    text: '', 
                    value: 'editForm',
                    align: 'right', 
                    sortable: false, 
                    width: "70px"
                }
            ]
        },
        qualityItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_CONTRACTS_CAPTION_QUALITY_IS_GROUPED'), 
                    value: 'isGrouped',
                    alvqa: this.alvqa + '-list-dropdown-quality-isgrouped'
                },
            ]
        }
    },
    methods: {
        getTrackLangConst(amount) {
            if(amount === 0 || amount > 1) return "lang_GENERIC_TRACKS_PLURAL"
            else return "lang_GENERIC_TRACKS_SINGULAR"
        },
    }
}
</script>